module.exports = __webpack_public_path__ + "v1.0.0/img/page_loading.80b14bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/page_loading.svg
// module id = NHdK
// module chunks = 1 2 3 4 5 6 7 8 9 10